// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2dx9v","listItem":"listItem--2O-Q5"};